import { isOldPracticeMaterialsEnabled } from '@lingoda/monolith-feature-flags';
import type { SectionName } from '@lingoda/sections';
import type { Module } from './models';

export const isNotLegacyModule = (expandedModule: Module) => !/old/i.exec(expandedModule.code);

export const moduleIsAvailableForSelection = (module: { code: string }) => {
    return ['Open discussion'].every(
        (ignoredCode) => module.code.toLowerCase() !== ignoredCode.toLowerCase(),
    );
};

const checkModuleLevel = (moduleName: string, level: 'a' | 'b' | 'c') => {
    return moduleName.toLowerCase().startsWith(level);
};

// 📝 Always enabled for `c` level modules, for others based on feature flag
// Old practice materials are Easygenerator and H5P exercises
export const isOldPracticeEnabled = (moduleName: string, sectionName?: SectionName) => {
    // C1 English follows the new curriculum, its old practice materials are outdated
    if (sectionName === 'english' && checkModuleLevel(moduleName, 'c')) {
        return false;
    }

    return isOldPracticeMaterialsEnabled() || checkModuleLevel(moduleName, 'c');
};
